import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.34 17.434c.503.597 1.402.68 1.928.104a10.48 10.48 0 0 0 2.09-10.665 10.5 10.5 0 0 0-3.87-5 10.51 10.51 0 0 0-12.066.062 10.5 10.5 0 0 0-3.817 5.04 10.47 10.47 0 0 0 2.201 10.643c.531.571 1.43.479 1.926-.124.495-.601.395-1.482-.107-2.078A7.66 7.66 0 0 1 3.267 7.92a7.67 7.67 0 0 1 2.79-3.684 7.684 7.684 0 0 1 11.649 3.609 7.65 7.65 0 0 1-1.28 7.511c-.496.6-.586 1.483-.085 2.08"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.3",
      d: "m6 12 2.333-2L10 11.429l3.666-3.143M11.172 8H14v2.424"
    }, null, -1)
  ])))
}
export default { render: render }